import React from 'react';
import Modal from './Modal';
function Bookmark(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="pop_bookmark">
      <h2 className="pop_tit line">즐겨찾기</h2>
      <div className="content_container scroll mb_no">
        <ul className="com_input_sec">
          <li className="input_field">
            <select name="" id="" className="select">
              <option value="GNB 메뉴 선택">GNB 메뉴 선택</option>
            </select>
          </li>
          <li className="input_field">
            <select name="" id="" className="select">
              <option value="하위메뉴 선택">하위메뉴 선택</option>
            </select>
          </li>
          <li className="input_field">
            <div className="com_btn_wrap center">
              <button className="com_btn orange line s full">추가</button>
            </div>
          </li>
          <li className="input_field">
            <div className="bookmarks">
              <div className="item">
                <button className="btn_bookmark_del"></button> 상세정보
              </div>

              <div className="item">
                <button className="btn_bookmark_del"></button> 수업등록 요청
              </div>
              <div className="item">
                <button className="btn_bookmark_del"></button> 시범강의 요청
              </div>
              <div className="item">
                <button className="btn_bookmark_del"></button> 수업진행 보고서 관리
              </div>
              <div className="item">
                <button className="btn_bookmark_del"></button> 포인트 요청
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs full">확인</button>
      </div>
    </Modal>
  );
}

export default Bookmark;
